"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlasmaManagerFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var PlasmaManagerFactory = /** @class */ (function (_super) {
    __extends(PlasmaManagerFactory, _super);
    function PlasmaManagerFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    PlasmaManagerFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    PlasmaManagerFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    PlasmaManagerFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    PlasmaManagerFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    PlasmaManagerFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return PlasmaManagerFactory;
}(contracts_1.ContractFactory));
exports.PlasmaManagerFactory = PlasmaManagerFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: '_startBlockNumber',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_bunchDepth',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_bunchIndex',
                type: 'uint256',
            },
        ],
        name: 'NewBunchHeader',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        inputs: [],
        name: 'getAllValidators',
        outputs: [
            {
                internalType: 'address[]',
                name: '',
                type: 'address[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_bunchIndex',
                type: 'uint256',
            },
        ],
        name: 'getBunchHeader',
        outputs: [
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'startBlockNumber',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'bunchDepth',
                        type: 'uint256',
                    },
                    {
                        internalType: 'bytes32',
                        name: 'transactionsMegaRoot',
                        type: 'bytes32',
                    },
                    {
                        internalType: 'bytes32',
                        name: 'receiptsMegaRoot',
                        type: 'bytes32',
                    },
                    {
                        internalType: 'bytes32',
                        name: 'lastBlockHash',
                        type: 'bytes32',
                    },
                ],
                internalType: 'struct PlasmaManager.BunchHeader',
                name: '',
                type: 'tuple',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getNextStartBlockNumber',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_validatorIndex',
                type: 'uint256',
            },
        ],
        name: 'getValidator',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_validator',
                type: 'address',
            },
        ],
        name: 'isValidator',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'lastBunchIndex',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: '_validators',
                type: 'address[]',
            },
        ],
        name: 'setInitialValidators',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_startBlockNumber',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_bunchDepth',
                type: 'uint256',
            },
            {
                internalType: 'bytes32',
                name: '_txMRoot',
                type: 'bytes32',
            },
            {
                internalType: 'bytes32',
                name: '_rcMRoot',
                type: 'bytes32',
            },
            {
                internalType: 'bytes32',
                name: '_lastBlockHash',
                type: 'bytes32',
            },
            {
                internalType: 'bytes[]',
                name: '_sigs',
                type: 'bytes[]',
            },
        ],
        name: 'submitBunchHeader',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=PlasmaManagerFactory.js.map